import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';

import { TrainingTypeEnum } from '@/constants/trainingTypeOptions';
import api from '@/services/apiSgft';
import { PositionTrainingMatrixFilters } from '@/state/PositionTrainingMatrixFilter.atom';
import { RegulatoryIndicators } from '@/types/Training';

export const useIndicators = () => {
	const [indicators, setIndicators] = useState<RegulatoryIndicators>();
	const [isLoading, setIsLoading] = useState(false);

	const fetchIndicators = useCallback(
		async (filters: PositionTrainingMatrixFilters) => {
			setIsLoading(true);
			try {
				const response = await api.get('trainings/regulatory-indicators', {
					params: {
						locations: filters.location,
						trainings: filters.training,
						positions: filters.position,
						trainingType: [TrainingTypeEnum.REGULATORY],
						management: filters.management,
						areaCoordination: filters.areaCoordination,
					},
				});
				setIndicators(response.data);
			} catch (e) {
				toast.error('Erro ao carregar indicadores', {
					theme: 'colored',
					toastId: 'error',
				});
				throw e;
			} finally {
				setIsLoading(false);
			}
		},
		[],
	);

	return {
		indicators,
		isLoading,
		fetchIndicators,
	};
};
